import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

// Checkbox para ativar/desativar a exibição dos campos de endereço comercial.

const ToggleCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;

  input {
    cursor: pointer;
    width: 18px;
    height: 18px;
  }

  label {
    cursor: pointer;
    font-weight: 600;
    color: ${colors.darkBlue};
    margin: 0;
  }
`;

/**
 * @param {boolean} props.showCommercial - Estado atual do checkbox
 * @param {Function} props.onToggle - Callback chamado ao clicar
 */
export const CommercialToggle = ({ showCommercial, onToggle }) => (
  <ToggleCheckbox>
    <input
      type="checkbox"
      id="temEnderecoComercial"
      name="temEnderecoComercial"
      checked={showCommercial}
      onChange={onToggle}
    />

    <label htmlFor="temEnderecoComercial">
      Possuo endereço comercial
    </label>
  </ToggleCheckbox>
);
